import { DateFormatter } from '@inter-ikea-kompis/utilities';
import FilerSaver from 'file-saver';
const FILENAME_PREFIX = 'NavisionExport';
const SHORTCUT_KEYS = ['e', 's'];
/**
 * Navision export.
 */
export default class NavisionExport {
    constructor() {
        this.shoppingItems = [];
        this.listeners = { keydown: this.onKeydown.bind(this) };
    }
    /**
     * Start listening to keyboard commands.
     * Note: Should only connect if localizedInformation.localization.saleSystem !== SaleSystem.isell.
     */
    connect() {
        document.addEventListener('keydown', this.listeners.keydown);
    }
    /**
     * Stops listening to keyboard commands.
     */
    disconnect() {
        document.removeEventListener('keydown', this.listeners.keydown);
    }
    /**
     * Returns shopping items.
     *
     * @returns Current shopping items.
     */
    getShoppingItems() {
        return this.shoppingItems;
    }
    /**
     * Set shopping items.
     *
     * @param shoppingItems Shopping items.
     */
    setShoppingItems(shoppingItems) {
        this.shoppingItems = shoppingItems;
    }
    /**
     * Keydown event listener to catch assigned shortcut.
     *
     * @param event Event object.
     */
    onKeydown(event) {
        if (event.ctrlKey && event.shiftKey && SHORTCUT_KEYS.includes(event.key.toLowerCase())) {
            this.saveFile();
        }
    }
    /**
     * Triggers a file save.
     */
    saveFile() {
        const blob = this.getBlob(this.getShoppingItems());
        const filename = this.getFilename(new Date());
        FilerSaver.saveAs(blob, filename);
    }
    /**
     * Generate blob with items.
     *
     * @param shoppingItems Items to generate blob.
     * @returns Text blob with items.
     */
    getBlob(shoppingItems = []) {
        const textContent = shoppingItems
            .map(function (item) {
            return [item.id, item.type, item.quantity].join('\t');
        })
            .join('\r\n') + '\r\n';
        const blob = new Blob([textContent], {
            type: 'text/plain;charset=ANSI'
        });
        return blob;
    }
    /**
     * Generate file name.
     *
     * @param date Date to be included in file name.
     * @returns File name.
     */
    getFilename(date) {
        const dateString = DateFormatter.dateToString(date, 'YYYY-MM-DD HH.mm');
        const filename = `${FILENAME_PREFIX} ${dateString}.txt`;
        return filename;
    }
}
//# sourceMappingURL=NavisionExport.js.map